import request from '@/utils/request';

const giftApiList = [
  // 获取待办
  ['getUpComingList', 'POST', '/treasure/process/todo/list'],
  // 获取已经办
  ['getDoneList', 'POST', '/treasure/process/done/list'],
  // 获取详情
  ['getDetailsUrl', 'GET', '/treasure/oauth/pc/authorize'],
]

let apiListMap = giftApiList.reduce((sum, prev) => {
  if (!prev || !prev[0] || !prev[1]) return sum
  sum[prev[0]] = prev
  return sum
}, {})

export function fetchData (apiName, payload, data) {
  const api = apiListMap[apiName];
  let options = {
    url: api[2],
    method: api[1],
    params: payload,
    data: data
  }
  return request(options)
}

